import { FunctionComponent } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { ButtonVariant } from 'react-bootstrap/esm/types';

interface ButtonIconProps {
    icon?: IconDefinition;
    name?: string;
    variant?: ButtonVariant;
    size?: 'sm' | 'lg';
    tooltip?: string;
    onClick?: () => void;
    disabled?: boolean;
    spin?: boolean;
}

const ButtonIcon: FunctionComponent<ButtonIconProps> = ({
    icon = faEye,
    name = '',
    variant = 'outline-secondary',
    size = 'sm',
    tooltip,
    onClick = () => { },
    disabled = false,
    spin = false,
    ...rest
}) => {
    const renderTooltip = (props: any) => (
        <Tooltip id="button-tooltip" {...props}>
            {tooltip ?? name}
        </Tooltip>
    );

    return (
        <>
            {!tooltip ? (
                <Button
                    {...rest}
                    variant={variant}
                    size={size}
                    onClick={onClick}
                    disabled={disabled}
                >
                    <FontAwesomeIcon icon={icon} spin={spin} /> {name}
                </Button>
            ) : (
                <OverlayTrigger
                    placement='bottom'
                    delay={{ show: 250, hide: 200 }}
                    overlay={renderTooltip}
                >
                    <Button
                        {...rest}
                        variant={variant}
                        size={size}
                        onClick={onClick}
                        disabled={disabled}
                    >
                        <FontAwesomeIcon icon={icon} spin={spin} /> {name}
                    </Button>
                </OverlayTrigger>
            )}
        </>
    );
};

ButtonIcon.propTypes = {
    icon: PropTypes.object as PropTypes.Validator<IconDefinition>,
    name: PropTypes.string.isRequired,
    variant: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'lg', null, undefined]),
    tooltip: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    spin: PropTypes.bool,
};

export default ButtonIcon;
